import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Interval } from 'luxon';
import { IEpisode } from 'src/app/core/services/extended-program-guide.service';
import { ICalculatedEpisodePosition } from '../../episodes-calendar-view/utils/calculateEpisodePosition';

/**
 * Represents a processed program object. This data structure is used to represent database programs into many when needed.
 * For example, for the following program data:
 *
 * - Duration: 1 hour
 * - Start date: November 27 at 10:00 AM (Monday)
 * - End date: December 8 at 10:00 AM (Friday)
 * - Recurrence: Repeat for 2 weeks on Monday, Wednesday, Friday
 *
 * We should have the following `IDayProgram` objects:
 *
 * - November 27, 10:00 AM - 11:00 AM (Monday)
 * - November 29, 10:00 AM - 11:00 AM (Wednesday)
 * - December 1, 10:00 AM - 11:00 AM (Friday)
 * - December 4, 10:00 AM - 11:00 AM (Monday)
 * - December 6, 10:00 AM - 11:00 AM (Wednesday)
 * - December 8, 10:00 AM - 11:00 AM (Friday)
 */
export interface IDayProgram {
  /**
   * program range on the current day
   */
  range: Interval;
  formatted: {
    /**
     * formatted range of the program, as in the mockup (e.g. 10:00 AM - 11:00 AM)
     */
    range: string;
  };
  name: string;
  description: string;
  /**
   * program original object
   */
  program: IEpisode;
  /**
   * Normalized program positions
   */
  position: ICalculatedEpisodePosition;
}

@Component({
    selector: 'app-schedule-program',
    templateUrl: './schedule-program.component.html',
    styleUrls: ['./schedule-program.component.scss'],
    standalone: false
})
export class ScheduleProgramComponent implements OnInit {
  public showEpisodeOptions = false;
  public isMouseOverOverlay = false;
  public isInitialOverlay = false;

  @Input() program: IDayProgram;
  @Input() readOnly: boolean = false;

  @Output() public readonly onEdit = new EventEmitter<IDayProgram>();

  public constructor() {}

  public ngOnInit(): void {}

  public onMouseEnter() {
    this.showEpisodeOptions = true;
    this.isInitialOverlay = true;
  }

  public onMouseLeave() {
    this.onMouseLeaveProgramElement();
  }

  public onMouseOut() {
    this.onMouseLeaveProgramElement();
  }

  public onMouseLeaveProgramElement() {
    if (this.isInitialOverlay) {
      this.isInitialOverlay = false;
      return;
    }
    if (this.isMouseOverOverlay) {
      return;
    }
    this.showEpisodeOptions = false;
  }

  public onMouseEnterOverlay() {
    this.isMouseOverOverlay = true;
  }

  public onMouseLeaveOverlay() {
    this.isMouseOverOverlay = false;
  }

  public getTooltipText(): string {
    const { name, formatted, program } = this.program;
    return `${name} \n  ${program.options.episode.title} \n ${formatted.range}`;
  }
}
